/**
 * Formato de fechas para la SPA.
 *
 * POR QUÉ EXISTE ESTE ARCHIVO. El backend distingue dos cosas que el navegador confunde:
 * `DateOnly` para fechas contables y `DateTime` UTC para instantes (ver CLAUDE.md). Esa
 * distinción se pierde al llegar como cadena, y tratarlas igual produce un defecto silencioso.
 *
 * `new Date('2026-01-01')` es **medianoche UTC**. En México —UTC-6 todo el año— eso cae el
 * 31 de diciembre a las 18:00, así que `toLocaleDateString` pinta el día anterior. Para un
 * instante la conversión es correcta y deseada; para una fecha contable es sencillamente un
 * día equivocado.
 *
 * Se encontró en tres pantallas a la vez, incluida una que pintaba un **plazo legal** (RN-08)
 * un día antes mientras el tablero pintaba el correcto: dos pantallas discrepando sobre la
 * misma fecha de vencimiento.
 */

/**
 * Una fecha contable (`DateOnly`: `2026-01-01`), sin conversión de zona horaria.
 *
 * Úsala para todo lo que el backend declara `DateOnly`: inicio de operaciones, fecha límite de
 * una obligación, fecha de publicación de un catálogo. **No** la uses para un campo con sufijo
 * `Utc`: ahí la conversión a hora local es lo correcto.
 */
export const fechaContable = (iso: string): string =>
  new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString('es-MX')

/**
 * Una fecha contable en formato largo: «1 de enero de 2026». Mismo criterio que `fechaContable`.
 */
export const fechaContableLarga = (iso: string): string =>
  new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString('es-MX', {
    day: '2-digit', month: 'long', year: 'numeric',
  })
